// @flow

import styled, { css } from 'styled-components';
import { media } from '../../../../../../helpers';
import { BOLD } from '../../../../../../helpers/fontWeight';
import type { Theme } from '../../../../../../types';

export default styled<any, Theme>('h5')`
  font-weight: ${BOLD};
  color: ${props => props.theme.progressRow.price.color};
  font-size: ${props => props.theme.progressRow.price.fontSize};
  white-space: nowrap;
  display: block;

  ${media.lg(css`
    font-size: 1.5rem;
  `)}
`;
